import api from '@/api/metaInfo'

const state = {

}

const actions = {
  getMetaIndustryList (context, params) {
    return api.getMetaIndustryList(params)
  },
  getMetaJobFunctionList (context, params) {
    return api.getMetaJobFunctionList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
